/**
 * Patron Points status pills.
 *
 * The colour tokens are IMPORTED from `shared/ReviewShieldChips.jsx` — the
 * same six values Review Shield draws with. No new palette is defined here.
 * "Redeemed" has no token in that map, so it uses the shadcn `default` badge,
 * which is exactly what the Review Shield results page uses for a redeemed
 * voucher.
 *
 * Mapping:
 *   email accepted → green · no consent → grey · unsubscribed → amber
 *   voucher active → green · redeemed → default badge · expired → grey
 *   visited ≤30 days → green · 30–90 → amber · >90 or never → grey
 */
import { TOKEN } from '../../shared/ReviewShieldChips';
import { Badge } from '../../ui/badge';

const CHIP = 'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 '
    + 'text-[10px] font-medium whitespace-nowrap';

export const Chip = ({ tone, label, testId }) => (
    <span className={CHIP} data-testid={testId}
          style={{ background: tone.bg, borderColor: tone.ring, color: tone.fg }}>
        {label}
    </span>
);

export const EmailChip = ({ status, t, testId }) => {
    const tone = status === 'accepted' ? TOKEN.resolved
        : status === 'unsubscribed' ? TOKEN.awaiting : TOKEN.no_contact;
    return <Chip tone={tone} testId={testId}
                 label={t(`patronCommand.emailStatus.${status || 'none'}`)} />;
};

export const VisitChip = ({ recency, t, testId }) => {
    const tone = recency === 'recent' ? TOKEN.resolved
        : recency === 'fading' ? TOKEN.awaiting : TOKEN.no_contact;
    return <Chip tone={tone} testId={testId}
                 label={t(`patronCommand.recency.${recency || 'never'}`)} />;
};

export const PrizeChip = ({ state, t, testId }) => {
    if (state === 'redeemed') {
        return (
            <Badge variant="default" className="text-[10px]" data-testid={testId}>
                {t('patronCommand.prize.redeemed')}
            </Badge>
        );
    }
    const tone = state === 'active' ? TOKEN.resolved : TOKEN.no_contact;
    return <Chip tone={tone} testId={testId}
                 label={t(`patronCommand.prize.${state || 'none'}`)} />;
};

export const PlaceChip = ({ place, t, testId }) => (
    <Chip tone={place === 'remote' ? TOKEN.sla_new : TOKEN.no_contact}
          testId={testId} label={t(`patronCommand.place.${place || 'room'}`)} />
);
